import DefaultLightTheme from './light';
import DefaultDarkTheme from './dark';

export default {
  dark: DefaultDarkTheme,
  light: DefaultLightTheme,
};
